import Request from './request';

async function fetch(data, noLoading) {
    return Request('get', "api/report-downloads", data, noLoading);
}

async function read(id) {
    return Request('post', "api/report-downloads/web-read/" + id);
}

export default {
    fetch,
    read
};